import React from 'react'
import { useHistory } from 'react-router-dom'

import { DynamicPricingInterstitial } from 'components/DynamicPricingInterstitial'
import {
  User,
  useSubscribeAfterRegistrationCompleteMutation,
} from 'generated/types'
import { routes } from 'router/routes'

interface Props {
  authData: {
    user: User
  }
}

const EVENT_FUNNEL_VALUE = 'login_no_tier'

export function PricingInterstitial(props: Props) {
  const history = useHistory()
  const [subscribeToTier] = useSubscribeAfterRegistrationCompleteMutation()

  const handleCtaPress = async (tierId: string, tierPriceId: string) => {
    await subscribeToTier({
      variables: {
        input: {
          tierId,
          tierPriceId,
          userId: props.authData.user.uuid,
        },
      },
    })
    history.go(routes.present)
  }

  return (
    <DynamicPricingInterstitial
      handleCtaPress={handleCtaPress}
      eventFunnelValue={EVENT_FUNNEL_VALUE}
    />
  )
}
